<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        sm="8"
        offset-sm="2"
        md="6"
        offset-md="3"
      >
        <update-password-form />
      </v-col>
    </v-row>

    <v-row>
      <v-col
        cols="12"
        sm="8"
        offset-sm="2"
        md="6"
        offset-md="3"
      >
        <v-divider class="my-4" />
      </v-col>
    </v-row>


    <v-row class="mt-0">
      <v-col
        cols="12"
        sm="8"
        offset-sm="2"
        md="6"
        offset-md="3"
      >
        <v-btn
          class="float-right"
          type="submit"
          text
          color="error"
          @click="$inertia.visit(route('remove-account.index'))"
        >
          {{ $t('Remove my account') }}
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import i18n from '@/plugins/vue-i18n';
import Layout from '@/components/shared/TheLayout';
import UpdatePasswordForm from '@/components/account/UpdatePasswordForm';

export default {
  components: {
    UpdatePasswordForm
  },

  layout: (h, page) => h(Layout, {
    props: {
      pageTitle: i18n.t('Account')
    }
  }, [page]),
}
</script>